export default "__VITE_ASSET__BabKh9lC__"